import {clampOverlayCoordinate} from "./MapPopoverPosition.ts";

export const EDGE_GAP = 16;
export type PanelPosition = {right: number; top: number};
export type PanelSize = {containerWidth: number; containerHeight: number; panelWidth: number; panelHeight: number};
export const DEFAULT_POSITION: PanelPosition = {right: EDGE_GAP, top: 144};

export function clampPanelPosition(position: PanelPosition, size: PanelSize): PanelPosition {
    if (!size.containerWidth || !size.containerHeight) return position;
    return {
        right: clampOverlayCoordinate(position.right, size.containerWidth, size.panelWidth, EDGE_GAP),
        top: clampOverlayCoordinate(position.top, size.containerHeight, size.panelHeight, EDGE_GAP),
    };
}

// Saved positions refer to the main panel, independent of its open right dock.
export function anchoredPanelPosition(position: PanelPosition, size: PanelSize, rightDockWidth: number): PanelPosition {
    return clampPanelPosition({...position, right: position.right - rightDockWidth}, size);
}
